import React from "react";

const ModalTitle = props => {
  return (
    <div className="mod-title" {...props}>
      {props.title}
      <i onClick={props.onRequestClose} className="ion ion-close pull-right close-modal" />
    </div>
  );
};

export default ModalTitle;



// WEBPACK FOOTER //
// ./src/components/common/modalTitle.js